/* unplugin-vue-components disabled */import script from "./question.vue?vue&type=script&setup=true&lang=js"
export * from "./question.vue?vue&type=script&setup=true&lang=js"

import "./question.vue?vue&type=style&index=0&id=1e9ba658&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e9ba658"]])

export default __exports__